export const containerStyles = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: '4px',
};
